String.prototype.replaceAll = function(strReplace, strWith) {
    // See http://stackoverflow.com/a/3561711/556609
    var esc = strReplace.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    var reg = new RegExp(esc, 'ig');
    return this.replace(reg, strWith);
};

class SmzSearch {
    constructor(content, inputEl, resultEl, categories, options = {}){
        this.content = content;
        this.input = inputEl;
        this.result = resultEl;
        this.storeCurrency = JSON.parse(document.getElementById('cart-json').textContent);
        this.categories = categories;
        this.searchPause = false;
        this.options = Object.assign(
            {},
            {  
                root: ""
            }, 
            options 
        );  
        this.timeKey = setTimeout(function(){});
 
        this.content.querySelector(".btn-search").addEventListener('click', event => {
            clearTimeout(this.timeKey);
            if(!this.searchPause){ 
                this.input.closest(".content-input-search").classList.add("loading"); 
                this.timeKey = setTimeout(function(){ 
                    if(this.input.value != ""){ 
                        this.searchPause = true;
                        this.searchApi(this.input.value); 
                    }else{
                        this.input.closest(".content-input-search").classList.remove("loading");
                        this.result.innerHTML = "";
                        this.categories.querySelector(" .all .count").innerHTML = 0;
                        this.categories.querySelector(".products .count").innerHTML = 0;
                        this.categories.querySelector(".pages .count").innerHTML = 0;
                        this.categories.querySelector(".articles .count").innerHTML = 0;
                        if(this.categories.querySelector(".cat.selected") != null){
                            this.categories.querySelector(".cat.selected").classList.remove("selected");
                        }
                        if(this.input.closest(".content-input-search").classList.contains("loading")){
                            this.input.closest(".content-input-search").classList.remove("loading");
                        }
                        if(this.result.classList.contains("show")){
                            this.result.classList.remove("show");
                        }
                        if(!document.querySelector("#search .best-search").classList.contains("on")){
                            document.querySelector("#search .best-search").classList.add("on");
                        }
                    }
                }.bind(this), 500); 
            }
        });
      
        this.input.addEventListener('keydown', event => {
            if (event.key === 'Enter') {
                event.preventDefault(); // Prevent form submission
                this.content.querySelector(".btn-search").click(); // Trigger the button click
            }
        });

        /*
        this.input.addEventListener('keyup', event => {
            clearTimeout(this.timeKey);
            if(!this.searchPause){ 
                this.input.closest(".content-input-search").classList.add("loading");
                //this.result.innerHTML = "";
                this.timeKey = setTimeout(function(){ 
                    if(event.target.value != ""){ 
                        this.searchPause = true;
                        this.searchApi(event.target.value); 
                    }else{
                        this.input.closest(".content-input-search").classList.remove("loading");
                        this.result.innerHTML = "";
                        this.categories.querySelector(" .all .count").innerHTML = 0;
                        this.categories.querySelector(".products .count").innerHTML = 0;
                        this.categories.querySelector(".pages .count").innerHTML = 0;
                        this.categories.querySelector(".articles .count").innerHTML = 0;
                        if(this.categories.querySelector(".cat.selected") != null){
                            this.categories.querySelector(".cat.selected").classList.remove("selected");
                        }
                        if(this.input.closest(".content-input-search").classList.contains("loading")){
                            this.input.closest(".content-input-search").classList.remove("loading");
                        }
                        if(this.result.classList.contains("show")){
                            this.result.classList.remove("show");
                        }
                        if(!document.querySelector("#search .best-search").classList.contains("on")){
                            document.querySelector("#search .best-search").classList.add("on");
                        }
                    }
                }.bind(this), 500); 
            }
        });
        */
        this.popularResult();
    }

    async searchApi(q) {  
        //option : product,page,article,collection
        if( document.querySelector("#search .best-search.on") != null){
            document.querySelector("#search .best-search.on").classList.remove("on");
        } 
        const call = await fetch(`${this.options.root}search/suggest.json?q=${q}&resources[type]=product,page,article&resources[options][fields]=title,product_type,tag` , {
            method: "GET",
            credentials: 'same-origin'
        });
        const result = await call.json();  
        this.builResult(q, result.resources.results);
        if(this.input.closest(".content-input-search").classList.contains("loading")){
            this.input.closest(".content-input-search").classList.remove("loading");
        } 
        trackNov.push({
            "event" : "search",
            "search_term" : q  
        }); 
    }   

    async popularResult(){ 
        const call = await fetch(`/recommendations/products.json?product_id=3940324016216&limit=4&intent=related` , {
            method: "GET",
            credentials: 'same-origin'
        });
        const result = await call.json();  
        this.buildPopularSearch(result.products); 
        //this.builResult(q, result.resources.results);
        /*
        if(this.input.closest(".content-input-search").classList.contains("loading")){
            this.input.closest(".content-input-search").classList.remove("loading");
        }*/
    }

    buildPopularSearch(prds){ 
        let list = document.createElement("ul");
        prds.forEach(prd => {
            let ent = document.createElement("li");
            let entSpan = document.createElement("span");
            entSpan.classList.add("search-reco");
            entSpan.innerHTML = prd.title;
            entSpan.setAttribute("data-reco", prd.handle);
            entSpan.setAttribute("data-title", prd.title);
            ent.appendChild(entSpan);
            list.appendChild(ent);

            ent.addEventListener("click", () => {
                this.input.closest(".content-input-search").classList.add("loading");
                this.input.value = prd.title;
                this.searchApi(prd.title);  
            });
        }); 
        document.querySelector("#search .best-search").classList.add("on"); 
        document.querySelector("#search .best-search .s").appendChild(list); 
    }

    callAutoSearch(q){

    }

    buildResultatByType(q, datas, type, all){
        if(all){
            var content = document.createElement("div"); 
            content.classList.add(`result-all`);  ; 
        }else{
            var content = document.createElement("div"); 
            content.classList.add(`content-result-${type}s`); 
            content.classList.add("resultat"); 
            content.setAttribute("data-result", `${type}s`); 
        } 
        var count = 0;
        if(datas.length > 0){ 
            datas.forEach(d => {  
                let hide = false;
                if(typeof d.tags != "undefined"){
                    d.tags.forEach(t => {
                        if(t == "hide"){
                            hide = true;
                        }
                    });
                }   
                if(typeof d.type != "undefined" && d.type == "VP23"){
                    hide = true; 
                }
                if(typeof d.handle != "undefined" && d.handle == "ventes-privees-ete-2023"){
                    hide = true; 
                }
                if(!hide){ 
                    var r = document.createElement("a");
                    r.setAttribute("href", d.url);
                    r.classList.add("result");  
 
                    // Convertit le titre et la recherche en minuscules sans accents
                    var titreSansAccents = d.title.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                    var rechercheSansAccents = q.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                    
                    // Recherche la chaîne dans le titre
                    var index = titreSansAccents.indexOf(rechercheSansAccents);
                    
                    // Si la chaîne est trouvée, surligne la partie correspondante
                    if (index !== -1) {
                        var debut = d.title.substring(0, index);
                        var milieu = d.title.substring(index, index + q.length);
                        var fin = d.title.substring(index + q.length);
                    
                        var titreSurligne = debut + "<span>" + milieu + "</span>" + fin;

                        var newTitle =  titreSurligne    
                    } else { 
                        var newTitle =  d.title;   
                    }    
                    if(type == "product"){
                        var price = this.formatPrice(d.price,this.storeCurrency.currency);  
                    }
                    var resultHtml = "";

                    var iconPage = `<svg version="1.1" class="icon-page" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 78 100" style="enable-background:new 0 0 78 100;" xml:space="preserve">
                        <g>
                            <path d="M67,87V2c0-0.83-0.67-1.5-1.5-1.5h-64C0.67,0.5,0,1.17,0,2v85c0,0.83,0.67,1.5,1.5,1.5h64C66.33,88.5,67,87.83,67,87z M64,85.5H3v-82h61V85.5z"/>
                            <path d="M76.5,11.5H71c-0.83,0-1.5,0.67-1.5,1.5s0.67,1.5,1.5,1.5h4v82H14v-5c0-0.83-0.67-1.5-1.5-1.5c-0.83,0-1.5,0.67-1.5,1.5V98 c0,0.83,0.67,1.5,1.5,1.5h64c0.83,0,1.5-0.67,1.5-1.5V13C78,12.17,77.33,11.5,76.5,11.5z"/>
                            <path d="M14,23.5h38c0.83,0,1.5-0.67,1.5-1.5s-0.67-1.5-1.5-1.5H14c-0.83,0-1.5,0.67-1.5,1.5S13.17,23.5,14,23.5z"/>
                            <path d="M14,38.5h38c0.83,0,1.5-0.67,1.5-1.5c0-0.83-0.67-1.5-1.5-1.5H14c-0.83,0-1.5,0.67-1.5,1.5C12.5,37.83,13.17,38.5,14,38.5z"/>
                            <path d="M14,52.5h38c0.83,0,1.5-0.67,1.5-1.5c0-0.83-0.67-1.5-1.5-1.5H14c-0.83,0-1.5,0.67-1.5,1.5C12.5,51.83,13.17,52.5,14,52.5z"/>
                            <path d="M14,69.5h21c0.83,0,1.5-0.67,1.5-1.5s-0.67-1.5-1.5-1.5H14c-0.83,0-1.5,0.67-1.5,1.5S13.17,69.5,14,69.5z"/>
                        </g>
                    </svg>`;


    
                    resultHtml = `<div class="content-image">`
                                            + `<div class="image">`;
                                                if(d.image != null){
                                                    resultHtml += `<img src="${d.image}" />`
                                                }else{
                                                    resultHtml += iconPage
                                                }
                                            resultHtml += `</div>`
                                        + `</div>`; 

                    resultHtml += `<div class="content-desc">`  
                                            + `<h3>${newTitle}</h3>` 
                                            + `<p></p>` 
                                        + `</div>`;  
                                        if(type == "product"){
                                            resultHtml += `<div class="content-price">`
                                                + `<div class="price">${price}</div>`
                                            + `</div>`  
                                        }

                    r.innerHTML = resultHtml;
                    if(type == "product" && parseInt(d.price) != 0){
                        content.append(r);
                        count++;
                    }
                    if(type == "page" || type == "article" ){ 
                        content.append(r);
                        count++; 
                    }
                }
            });
        }else{
            if (all){
                content.innerHTML = "";
            }else{
                content.innerHTML = "Aucun résultat";
            }
        }
        if(count == 0){
            if (all){
                content.innerHTML = "";
            }else{
                content.innerHTML = "Aucun résultat";
            }
        }
        return content;
    }

    async builResult(q, result){ 
        this.result.innerHTML = "";  
        var selected = false; 
        
        this.categories.querySelector(".all .count").innerHTML = result.products.length + result.pages.length + result.articles.length;
        this.categories.querySelector(".products .count").innerHTML = result.products.length;
        this.categories.querySelector(".pages .count").innerHTML = result.pages.length;
        this.categories.querySelector(".articles .count").innerHTML = result.articles.length;
         
        var productsHtml = this.buildResultatByType(q, result.products, "product");
        var pagesHtml = this.buildResultatByType(q, result.pages, "page");
        var articlesHtml = this.buildResultatByType(q, result.articles, "article"); 


        var content = document.createElement("div"); 
        content.classList.add(`content-result-all`); 
        content.classList.add("resultat"); 
        content.setAttribute("data-result", `all`);  


        content.appendChild(this.buildResultatByType(q, result.products, "product", true)); 
        content.appendChild(this.buildResultatByType(q, result.articles, "article", true)); 
        content.appendChild(this.buildResultatByType(q, result.pages, "page", true)); 
        this.result.appendChild(content);
 

        this.result.appendChild(productsHtml);
        this.result.appendChild(pagesHtml);
        this.result.appendChild(articlesHtml);


        if((result.products.length + result.pages.length + result.articles.length ) > 0 && !selected){
            this.categories.querySelector(".all").classList.add("selected"); 
            this.result.querySelector(".resultat[data-result='all']").classList.add("selected");
            selected = true;
        } 
        if(result.products.length > 0 && !selected){
            this.categories.querySelector(".products").classList.add("selected"); 
            this.result.querySelector(".resultat[data-result='products']").classList.add("selected");
            selected = true;
        }
        if(result.pages.length > 0 && !selected){
            this.categories.querySelector(".pages").classList.add("selected");
            this.result.querySelector(".resultat[data-result='pages']").classList.add("selected");
            selected = true;
        }
        if(result.articles.length > 0 && !selected){
            this.categories.querySelector(".articles").classList.add("selected");
            this.result.querySelector(".resultat[data-result='articles']").classList.add("selected");
            selected = true;
        }


        document.querySelectorAll(".content-categories .cat").forEach(cat => {
            cat.addEventListener("click", () => {
                if(!cat.classList.contains("selected")){
                    var dataResult = cat.getAttribute("data-result");
                    if(document.querySelector(".content-categories .cat.selected") != null){
                        document.querySelector(".content-categories .cat.selected").classList.remove("selected");
                        document.querySelector(".content-result .resultat.selected").classList.remove("selected");
                    }
                    cat.classList.add("selected");
                    document.querySelector(`.content-result .resultat[data-result='${dataResult}']`).classList.add("selected");
                }
            });
        });


        /*if(!this.result.classList.contains("show")){
                this.result.classList.add("show");
            }*/
        
        /*else{  
            if(this.result.classList.contains("show")){
                this.result.classList.remove("show");
            }
        }*/
        this.searchPause = false;

        // this.result.appendChild(resultPrd);
        // resultPrd.innerHTML = resultPrdHtml;
    }

    formatPrice(price, currency){ 
        switch(currency){
        default :
            return  price + ' ' + currency; 
        }
    } 

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    } 
} 